<template>
  <div id="chart">
    <apexchart type="area" height="100%" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import {nomeMeses, formatarValorMonetario} from "../../../../helpers/index";
import formatarValoresBi from "../../../../helpers/formatarValoresBi";
import {parametros_rota} from "../helpers/ParametrosRota";
import {logout} from "../../../../helpers";
import IndicadoresAPI from "../../../../api/indicadores.js";

const serie_default = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

export default {
  name: "RupturasFornecedor",
  mixins: [parametros_rota],
  data: () => ({
    rupturas: {
      referencias: [],
      tipos: {
        DRP: serie_default,
        COMPRA: serie_default
      }
    }
  }),
  computed: {
    options() {
      return {
        chart: {
          id: "chart-rupturas",
          type: "area",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          stacked: false,
        },
        grid: {
          show: true,
          position: "back",
          yaxis: {
            lines: {
              show: true
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        noData: {
          text: "Carregando... aguarde",
          align: "center",
          verticalAlign: "middle",
          style: {
            fontSize: "14px"
          }
        },
        stroke: {
          width: 2
        },
        markers: {
          size: 3,
          strokeWidth: 1.2,
          hover: {
            size: 7
          }
        },
        labels: [],
        dataLabels: {
          enabled: false,
          offsetY: -5,
          distributed: true,
          style: {
            fontSize: "11px",
            fontWeight: false,
            colors: ["#000"]
          },
          background: {
            enabled: false
          },
          formatter: function(val) {
            return formatarValoresBi(val);
          }
        },
        yaxis: {
          show: true,
          forceNiceScale: true,
          title: {
            text: "Perda de vendas por Rupturas",
            style: {
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title"
            }
          },
          labels: {
            formatter: function(val) {
              return formatarValoresBi(val, 0);
            }
          },
          min: 1,
        },
        xaxis: {
          categories: this.rupturas.referencias,
          labels: {
            minWidth: 50,
            maxWidth: 50,
            formatter: val => {
              if (typeof val === 'number') return 'Mês';

              const [numero_mes] = `${val}`.split("/");
              return `${nomeMeses[parseInt(numero_mes) - 1] || ''}`.substring(0, 3);
            }
          },
          tooltip: {
            enabled: false
          }
        },
        fill: {
          gradient: {
            type: "vertical",
            opacityFrom: 1,
            opacityTo: .8,
            stops: [10, 50, 100]
          }
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            formatter: val => {
              return (nomeMeses[val - 1] || ' ');
            }
          },
          y: {
            formatter: formatarValorMonetario
          }
        },
        legend: {
          show: true,
          position: "top",
          offsetY: 10,
          markers: {
            width: 13,
            height: 13,
            radius: 0
          }
        }
      };
    },
    series() {
      return [
        {
          name: "Rupturas por COMPRA",
          color: "rgba(214, 14, 43, 1)",
          data: this.rupturas.tipos.COMPRA
        }, {
          name: "Rupturas por DRP",
          color: "#FFBF00",
          data: this.rupturas.tipos.DRP
        }
      ];
    }
  },
  watch: {
    grupo_compra() {
      this.buscarRupturasDepartamento();
    },
    filial_compra() {
      this.buscarRupturasDepartamento();
    },
    departamento_compra() {
      this.buscarRupturasDepartamento();
    }
  },
  created() {
    this.buscarRupturasDepartamento();
  },
  methods: {
    buscarRupturasDepartamento() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupo_compra,
        filial: (this.filial_compra == 9999) ? 0 : this.filial_compra,
        iddepartamento: this.departamento_compra
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        IndicadoresAPI.getDadosPerdaVendaRupturaGrafico(headers, params)
          .then(resposta => {
            const {token, rupturas} = resposta.data;
            localStorage.token = token;
            this.rupturas = rupturas;
          })
          .catch(() => logout())
      );
    }
  }
}
</script>

<style scoped>
#chart {
  margin-top: -33px;
}
</style>
